

import { Bolt, Stars, BusinessCenter, RocketLaunch } from '@mui/icons-material';

const PLAN_DATA = [
  {
    id: 'free',
    name: 'Free',
    desc: 'For individuals & trials',
    basePriceINR: 0,
    perUserINR: 0,
    basePriceUSD: 0,
    perUserUSD: 0,

    idMonthly: 'plan_free_monthly',
    idAnnual: 'plan_free_annual',
    highlight: false,
    btnText: 'Start for Free',
    accentColor: '#94a3b8', // Slate
    icon: <Bolt fontSize="small" />,
    includedFeatures: [
      'Project selection for allocation: 1',
      'Active Open positions: 2',
      'Requisition Approval: Auto Approve',
      'Number of recruiters: 1',
      'Interview Panel: 1',
      'Number of active users: 3',
      'Roles: Admin, Recruiter and Interviewer.',
      'Candidate Pool limit: 20',
      'Candidate matching: Basic matching (Top 3 candidates disabled)',
      'Candidate matching weightage criteria: Fixed',
      'Integration with Meeting Platforms: Zoom',
      'Offer Letter: Manual upload',
      'Implementation/Onboarding: User Manual',
    ],
    excludedFeatures: [
      'Copy from past JD/Requisition',
      'Partial approval for Candidate Req',
      'Interview Pipeline View',
      'Post Ad to LinkedIn',
      'Fetch candidates from career email',
      'Send Candidate form via email',
      'Autofill from resume',
      'AI powered Candidate Matching',
      'Integration with AI interview agent (MeruBot)',
      'Custom Logo',
      'Share Employee joining form for filling details',
      'Bulk Employee upload',
      'Bulk Candidate upload',
      'Dashboard',
      'Reports',
      'Support',
      'Download data',
    ],
  },
  {
    id: 'standard',
    name: 'Standard',
    desc: 'Best for startup teams',

    // INR
    basePriceINR: 2000,
    perUserINR: 1000,

    // USD
    basePriceUSD: 35,
    perUserUSD: 18,

    includedUsers: 10,

    // Add-on users
    addonUserPriceINR: 1300,
    addonUserPriceUSD: 25,

    idMonthly: 'plan_NWz123MonthlyStd',
    idAnnual: 'plan_NWz123AnnualStd',
    highlight: false,
    btnText: 'Select Standard',
    accentColor: '#3b82f6', // Blue
    icon: <RocketLaunch fontSize="small" />,
    includedFeatures: [
      'Project selection for allocation: Unlimited',
      'Active Open positions: 25',
      'Copy from past JD/Requisition',
      'Requisition Approval: Manager Approval',
      'Number of recruiters: 5',
      'Interview Panel: Multiple (No option for different time slots)',
      'Number of active users: 10',
      'Roles: Admin, Delivery Manager, Project Manager, Hiring Manager, TA Manager, Recruiter, Interviewer',
      'Interview Pipeline View',
      'Candidate Pool limit: 250',
      'Post Ad to LinkedIn',
      'Fetch candidates from career email: 50/day',
      'Send Candidate form via email',
      'Autofill from resume',
      'Candidate matching: Advanced Matching',
      'Candidate matching weightage criteria: Custom',
      'AI powered Candidate Matching: Paid (No free credits) - Upcoming feature',
      'Integration with AI interview agent (MeruBot): 1500 free credits/month (No rollover). Additional credits available. Consumes 40 credits/min.',
      'Integration with Meeting Platforms: Teams/Google Meet, Zoom',
      'Offer Letter: Manual upload (Upcoming: Auto generation via System template)',
      'Custom Logo',
      'Share Employee joining form for filling details',
      'Bulk Employee upload: 25 per upload',
      'Bulk Candidate upload: 50 per upload',
      'Dashboard',
      'Reports: 10',
      'Support: Email support',
      'Implementation/Onboarding: Onboarding',
      'Download data',
    ],
    excludedFeatures: ['Partial approval for Candidate Req'],
  },
  {
    id: 'premium',
    name: 'Premium',
    desc: 'Built for growing teams',

    // INR
    basePriceINR: 5000,
    perUserINR: 900,

    // USD
    basePriceUSD: 80,
    perUserUSD: 14,

    includedUsers: 30,

    // Add-on users
    addonUserPriceINR: 1200,
    addonUserPriceUSD: 18,

    idMonthly: 'plan_PHx789MonthlyPrem',
    idAnnual: 'plan_PHx789AnnualPrem',
    highlight: true,
    btnText: 'Select Premium',
    accentColor: '#8b5cf6', // Violet
    icon: <Stars fontSize="small" />,
    includedFeatures: [
      'Project selection for allocation: Unlimited',
      'Active Open positions: 75',
      'Copy from past JD/Requisition',
      'Requisition Approval: Manager Approval',
      'Number of recruiters: 15',
      'Interview Panel: Multiple (Option to select different time slots for each panel)',
      'Number of active users: 30',
      'Roles: Admin, Delivery Manager, Project Manager, Hiring Manager, TA Manager, Recruiter, Interviewer',
      'Interview Pipeline View',
      'Candidate Pool limit: 750',
      'Post Ad to LinkedIn',
      'Fetch candidates from career email: 150/day',
      'Send Candidate form via email',
      'Autofill from resume',
      'Candidate matching: Advanced Matching',
      'Candidate matching weightage criteria: Custom',
      'AI powered Candidate Matching: Paid (No free credits) - Upcoming feature',
      'Integration with AI interview agent (MeruBot): 3000 free credits/month (No rollover). Additional credits available. Consumes 30 credits/min.',
      'Integration with Meeting Platforms: Teams, Zoom, Google meet',
      'Offer Letter: Manual upload (Upcoming: Auto generation via Custom template)',
      'Custom Logo',
      'Share Employee joining form for filling details',
      'Bulk Employee upload: 50 per upload',
      'Bulk Candidate upload: 100 per upload',
      'Dashboard',
      'Reports: 20',
      'Support: Email support, Dedicated CSM',
      'Implementation/Onboarding: Onboarding and Migration support',
      'Download data',
    ],
    excludedFeatures: ['Partial approval for Candidate Req'],
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    desc: 'Custom enterprise solution',
    basePriceINR: 0,
    perUserINR: 0,
    basePriceUSD: 0,
    perUserUSD: 0,
    priceMonthlyINR: 'Custom',
    priceMonthlyUSD: 'Custom',

    idMonthly: 'plan_enterprise_monthly',
    idAnnual: 'plan_enterprise_annual',
    highlight: false,
    btnText: 'Contact Sales',
    accentColor: '#10b981', // Emerald
    icon: <BusinessCenter fontSize="small" />,
    includedFeatures: [
      'Project selection for allocation: Unlimited',
      'Active Open positions: Unlimited',
      'Copy from past JD/Requisition',
      'Requisition Approval: Manager Approval',
      'Partial approval for Candidate Req',
      'Number of recruiters: Unlimited',
      'Interview Panel: Multiple (Option to select different time slots for each panel)',
      'Number of active users: Unlimited',
      'Roles: Admin, Delivery Manager, Project Manager, Hiring Manager, TA Manager, Recruiter, Interviewer',
      'Interview Pipeline View',
      'Candidate Pool limit: Unlimited',
      'Post Ad to LinkedIn',
      'Fetch candidates from career email: Unlimited',
      'Send Candidate form via email',
      'Autofill from resume',
      'Candidate matching: Advanced Matching',
      'Candidate matching weightage criteria: Custom',
      'AI powered Candidate Matching: Paid (100 free credits/month, No rollover) - Upcoming feature',
      'Integration with AI interview agent (MeruBot): 7500 free credits/month (No rollover). Additional credits available. Consumes 25 credits/min.',
      'Integration with Meeting Platforms: Teams, Zoom, Google meet',
      'Offer Letter: Manual upload (Upcoming: Auto generation via Custom template)',
      'Custom Logo',
      'Share Employee joining form for filling details',
      'Bulk Employee upload: Unlimited',
      'Bulk Candidate upload: Unlimited',
      'Dashboard',
      'Reports: 30+',
      'Support: Email support, Dedicated CSM, SLA backed response',
      'Implementation/Onboarding: Onboarding and Migration support',
      'Download data',
    ],
    excludedFeatures: [],
  },
];

export const getPlanData = () => PLAN_DATA;
